import { useEffect } from 'react';
import eventManager from './ApiEventManager';

export const useEventSubscriber = (eventType, id, callback) => {
    useEffect(() => {
        eventManager.subscribe(eventType, id, callback);

        return () => {
            eventManager.unsubscribe(eventType, id, callback);
        };
    }, [eventType, callback]);
};